import FolderNodeCollaps from './FolderNodeCollaps.component';

export default FolderNodeCollaps;